import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { pageTitleDecorator } from 'Decorators';
import { emailVerify } from 'Actions/auth';

@connect(null, dispatch => ({
    emailVerify: token => dispatch(emailVerify(token)),
}))
@pageTitleDecorator('verify')
export default class VerifyEmail extends React.Component {

    /**
     * @type {Object}
     */
    static propTypes = {
        match: PropTypes.object.isRequired,
        emailVerify: PropTypes.func.isRequired,
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    /**
     * Component Did Mount
     */
    componentDidMount() {
        const { emailVerify, match: { params: { token } } } = this.props;
        emailVerify(token);
    }

    render() {
        return null;
    }
}




// WEBPACK FOOTER //
// ./src/layouts/VerifyEmail/VerifyEmail.jsx